(function () {
  "use strict";

  function getCartContentEl() {
    return document.querySelector("cart-notification") || document.querySelector("cart-drawer");
  }

  function addToCart(variantId, button) {
    var feedbackEl = button.parentElement.querySelector(".fbt-add-feedback");
    var originalText = button.textContent;
    var cartContent = getCartContentEl();

    button.classList.add("is-loading");
    button.disabled = true;
    if (feedbackEl) feedbackEl.textContent = "";

    var body = {
      items: [{ id: variantId, quantity: 1 }]
    };

    if (cartContent && typeof cartContent.getSectionsToRender === "function") {
      body.sections = cartContent.getSectionsToRender().map(function (s) {
        return s.id;
      });
      body.sections_url = window.location.pathname;
    }

    fetch(window.Shopify.routes.root + "cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(body)
    })
      .then(function (response) {
        return response.json();
      })
      .then(function (data) {
        if (data.status) {
          throw new Error(data.description || "Could not add item to cart");
        }

        if (cartContent) {
          if (cartContent.classList.contains("is-empty")) {
            cartContent.classList.remove("is-empty");
          }
          if (typeof cartContent.renderContents === "function") {
            cartContent.renderContents(data);
          }
        }

        if (feedbackEl) feedbackEl.textContent = "Added!";
        button.textContent = originalText;
        button.classList.remove("is-loading");
        button.disabled = false;
      })
      .catch(function (error) {
        if (feedbackEl) feedbackEl.textContent = "Couldn't add item.";
        button.textContent = originalText;
        button.classList.remove("is-loading");
        button.disabled = false;
        console.error("FBT add to cart error:", error);
      });
  }

  document.addEventListener("click", function (event) {
    var button = event.target.closest(".fbt-add-btn");
    if (!button || button.disabled) return;
    event.preventDefault();
    var variantId = button.getAttribute("data-variant-id");
    if (!variantId) return;
    addToCart(variantId, button);
  });
})();
